
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerEditor()
    export class PsSetItemEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PsSetItemRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PsSetItemRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
